(function () {
  var wrap = document.querySelector('.hb-blog-index-wrap');
  if (!wrap) return;

  var sectionId = wrap.getAttribute('data-section-id');
  var grid = document.getElementById('hb-blog-index-grid-' + sectionId);
  var pagination = document.getElementById('hb-blog-index-pagination-' + sectionId);
  if (!grid || !pagination) return;

  var isLoading = false;
  var tickScheduled = false;

  function getNextUrl() {
    return pagination.getAttribute('data-next-url');
  }

  function loadNextPage() {
    var nextUrl = getNextUrl();
    if (!nextUrl || isLoading) return;

    isLoading = true;
    var loadMoreBtn = pagination.querySelector('[data-blog-load-more]');
    var originalLabel = loadMoreBtn ? loadMoreBtn.textContent : '';
    if (loadMoreBtn) loadMoreBtn.textContent = 'Ladataan…';

    var separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
    var sectionUrl = nextUrl + separator + 'section_id=' + sectionId;

    fetch(sectionUrl)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = document.createElement('div');
        doc.innerHTML = html;

        var newGrid = doc.querySelector('#hb-blog-index-grid-' + sectionId);
        var newPagination = doc.querySelector('#hb-blog-index-pagination-' + sectionId);

        if (newGrid) {
          while (newGrid.firstChild) {
            grid.appendChild(newGrid.firstChild);
          }
        }

        if (newPagination) {
          pagination.setAttribute('data-next-url', newPagination.getAttribute('data-next-url') || '');
          pagination.innerHTML = newPagination.innerHTML;
        }

        isLoading = false;
      })
      .catch(function () {
        isLoading = false;
        if (loadMoreBtn) loadMoreBtn.textContent = originalLabel;
      });
  }

  function checkScrollPosition() {
    tickScheduled = false;
    if (!getNextUrl() || isLoading) return;

    var triggerPoint = pagination.getBoundingClientRect().top;
    if (triggerPoint < window.innerHeight + 400) {
      loadNextPage();
    }
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!tickScheduled) {
        tickScheduled = true;
        requestAnimationFrame(checkScrollPosition);
      }
    },
    { passive: true }
  );

  // Manual click still works as a fallback/immediate trigger.
  pagination.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-blog-load-more]') : null;
    if (!link) return;
    e.preventDefault();
    loadNextPage();
  });

  checkScrollPosition();
})();